export enum UserRole {
    Admin = "Admin",
    Manager = "Manager",
    Staff = "Staff",
}
